import http from "../js/axios";
import { HOSPITAL_TYPES } from "../constants/hospital.contants";
import { formatTable } from "../js/common";
class HospitalSerive {
  create(data) {
    return http.post("/hospital/hospital_creation", data);
  }
  update(data) {
    return http.post("/hospital/hospital_creation", data);
  }
  updateStatus(data) {
    return http.post("/hospital/hospitalstatus", data);
  }
  removeFile(hospital_license_fileupload_mapping_id) {
    return http.post("/hospital/hospital_license_file_delete", {
      hospital_license_fileupload_mapping_id,
    });
  }

  get(doc) {
    doc.dml_indicator = "E";
    return http.post("/hospital/hospital_list", doc);
  }
  getHospitalName() {
    return http.post("/userlogin/hospital_name_list", { dml_indicator: "HS" });
  }
  validateEmailPhone(doc) {
    return http.post("/hospital/email_phone_check", doc);
  }
  list(doc) {
    doc.dml_indicator = "L";
    return http.post("/hospital/hospital_list", doc);
  }
  commonList() {
    return http.post("/hospital/hospital_list_common", {
      dml_indicator: "CMHL",
    });
  }
  getHospitalContacts(hospital_id) {
    return http.post("/hospital/hospital_list", {
      dml_indicator: "CL",
      hospital_id,
    });
  }
  getHospitalLicenses(hospital_id) {
    return http.post("/hospital/hospital_list", {
      dml_indicator: "LL",
      hospital_id,
    });
  }
  getHospitalOrgans(hospital_id) {
    return http.post("/hospital/hospital_list", {
      dml_indicator: "OL",
      hospital_id,
    });
  }

  upload(data) {
    return http.post("/ByteArrayAPI/hospital_license_files", data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
  uploadContact(data) {
    return http.post("/ByteArrayAPI/contact_person_fileup_load", data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
  uploadVideo(data) {
    return http.post("/ByteArrayAPI/video_fileupload", data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  parseItem(item) {
    item.type = this.getHospitalType(item.hospital_type);
    item.expiry_date = formatTable(item.license_expiry_date);
    return item;
  }
  getHospitalType(type) {
    let item = HOSPITAL_TYPES.find((item) => {
      return item.value == type;
    });
    return item != null ? item.name : "";
  }
  // Phase 2 - SBI SurePay payment (replaces BillDesk)
  generatePaymentBill(hospital_id) {
    return http.post("/hospital/payment_details", {
      hospital_id,
      payment_type: 1,
      dml_indicator: "NH",
    });
  }
  getLiverHospital(organ_type) {
    return http.post("/donor_registration/rota_hospital_order_list", {
      dml_indicator: "HL",
      organ_type: organ_type || 103,
    });
  }
  getRotaOrder(organ_type) {
    return http.post("/donor_registration/rota_hospital_order_list", {
      dml_indicator: "S",
      organ_type: organ_type || 103,
    });
  }
  getGovernmentRotaOrder(organ_type) {
    return http.post("/donor_registration/rota_hospital_ordergovernment", {
      rota_hospital_orderlist: [{ dml_indicator: "S", organ_type: organ_type || 103 }],
    });
  }
  addRotaOrder(data) {
    return http.post("/donor_registration/rota_hospital_order", data);
  }
  addGovermentRotaOrder(data) {
    return http.post("/donor_registration/rota_hospital_ordergovernment", data);
  }
  initPayment(data) {
    return http.post("/hospital/payment_details", data);
  }
  organHospitalList(doc) {
    return http.post("/hospital/organ_hospital_list", doc);
  }

  // Phase 1 Corrections - Get Districts by State (LGD codes)
  getDistrictsByState(state_id) {
    return http.get(`/hospital/get_districts_by_state?state_id=${state_id}`);
  }

  // Phase 1 Corrections - Get Taluks by District (LGD codes)
  getTaluksByDistrict(district_id) {
    return http.get(`/hospital/get_taluks_by_district?district_id=${district_id}`);
  }

  // Phase 1 Corrections - Get Hospitals with Post-mortem Facility
  getHospitalsWithPostmortem() {
    return http.get("/hospital/get_hospitals_with_postmortem");
  }

  // Save radio button value for fieldtype 2 attachments
  saveRadioValue(doc) {
    return http.post("/hospital/hospital_license_file_radio_save", doc);
  }
  // Phase 2 - KPME Certificate Verification
  verifyKPME(certificateNo) {
    return http.get(`/hospital/verify_kpme_certificate?CertificateNo=${encodeURIComponent(certificateNo)}`);
  }
  // Phase 2 - US-008: Approved doctors
  getApprovedDoctors(hospital_id) {
    return http.post("/hospital/approved_doctors", { hospital_id });
  }
  toggleApprovedDoctor(hospital_id, hospital_contact_id, is_approved_doctor) {
    return http.post("/hospital/toggle_approved_doctor", {
      hospital_id,
      hospital_contact_id,
      is_approved_doctor,
    });
  }
  // Phase 2 - US-008: Geolocation
  updateGeolocation(hospital_id, latitude, longitude) {
    return http.post("/hospital/update_geolocation", {
      hospital_id,
      latitude,
      longitude,
    });
  }
  // Phase 2 - US-008: Public hospital list
  getPublicHospitalList() {
    return http.get("/hospital/public_hospital_list");
  }
  // Phase 2 - ALF Approver Management
  getALFApprovers() {
    return http.post("/hospital/alf_approvers", {});
  }
  toggleALFApprover(registration_id, ALF_approver) {
    return http.post("/hospital/toggle_alf_approver", {
      registration_id,
      ALF_approver,
    });
  }
}
export default new HospitalSerive();
